import React from 'react';
import { Accordion } from 'react-bootstrap';
import { Icon } from 'lb-components';
import {
  Info as InfoIcon,
  Map,
} from 'lb-components/src/stories/assets/icons/payment';
import classNames from 'classnames';
import _ from 'lodash';

import inheritedClasses from '../Manual/Manual.module.scss';
import classes from './Info.module.scss';

const Info = ({
  platform,
  eventKey,
  logo,
  header,
  content,
  className,
  style,
  actionType,
  limit = '',
  navigate,
  t,
  ...props
}) => {
  return (
    <Accordion.Item
      eventKey={eventKey}
      className={classNames(
        inheritedClasses.container,
        classes.container,
        className
      )}
      style={{ flexDirection: 'column', width: '100%', ...style }}
      {...props}
    >
      <Header
        platform={platform}
        actionType={actionType}
        as={'div'}
        style={{ width: '100%', marginRight: 0 }}
        className={inheritedClasses.header}
      >
        <div
          className={classNames(inheritedClasses.logo)}
          style={{
            backgroundImage: `url(${logo})`,
            backgroundSize: _.includes(['EPay', 'Lb'], eventKey)
              ? '55%'
              : 'contain',
          }}
        />

        <div
          className={classes.right}
          style={{
            flex: 1,
            margin:
              actionType === 'deposit' && eventKey === 'Lb' ? '0 3%' : '0 5%',
          }}
        >
          {actionType === 'deposit' && eventKey === 'Lb' ? (
            <span
              onClick={(e) => {
                e.stopPropagation();
                navigate('/branches');
              }}
              style={{
                textDecoration: 'underline',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                fontFamily: 'lbet-st',
                fontSize: '1.6rem',
                color: 'rgb(64, 83, 161)',
                cursor: 'pointer',
                textAlign: 'right',
              }}
            >
              <Icon
                height={'2.5rem'}
                width={'1.9rem'}
                Icon={Map}
                style={{ marginRight: '1rem' }}
              />
              {t('სალაროები')}
            </span>
          ) : (
            <>
              <div className={inheritedClasses.info}>
                <Icon
                  Icon={InfoIcon}
                  type={'vec'}
                  height={'100%'}
                  width={'100%'}
                  style={{
                    maskSize: '90%',
                    WebkitMaskSize: '90%',
                    backgroundColor: '#5C74A5',
                  }}
                  onClick={(e) => e.stopPropagation()}
                />
                <p className={inheritedClasses.message}>
                  {actionType === 'deposit'
                    ? t('მინიმუმ, მაქსიმუმ')
                        .replace('${min}', limit?.min)
                        .replace('${max}', limit?.max)
                        .replace('${maxAmount}', limit?.maxAmount)
                    : t('მინიმუმ, მაქსიმუმ, საკომისიო')
                        .replace('${min}', limit?.min)
                        .replace('${max}', limit?.max)
                        .replace('${maxAmount}', limit?.maxAmount)
                        .replace('${fee}', limit?.fee)}
                </p>
              </div>

              <div className={classes.details}>
                {header}
              </div>
            </>
          )}
        </div>
      </Header>

      <Accordion.Body
        className={inheritedClasses.body}
        style={{ borderTop: '1px solid #DEDEDE' }}
      >
        <div
          style={{
            color: '#64687E',
            fontFamily: 'lbet-nus-regular',
            fontSize: '1.35rem',
            marginTop: '0.5rem',
          }}
        >
          {content}
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
};

const Header = ({ platform, actionType, children, ...props }) => {
  return (platform === 'mob' && actionType === 'withdraw') ? (
    <Accordion.Header {...props}>{children}</Accordion.Header>
  ) : (
    <div {...props}>{children}</div>
  );
};
export default Info;
